import { render } from "./TvmAppraisalAppointment.vue?vue&type=template&id=5f8947f8&scoped=true"
import script from "./TvmAppraisalAppointment.vue?vue&type=script&lang=js"
export * from "./TvmAppraisalAppointment.vue?vue&type=script&lang=js"

import "./TvmAppraisalAppointment.vue?vue&type=style&index=0&id=5f8947f8&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8947f8"]])

export default __exports__